var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo border-r dark:border-slate-800/50 rtl:border-r-0 rtl:border-l border-slate-50"},[_c('router-link',{attrs:{"to":_vm.dashboardPath,"replace":""}},[_c('img',{attrs:{"src":_vm.source,"alt":_vm.name}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }